import { configureStore } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { encryptTransform } from 'redux-persist-transform-encrypt';
import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import AuthSlice from '../slices/auth-slice';
import CartSlice from '../slices/cartSlice';
import CartEventSlice from '../slices/cart-event-slice';
import LanguageSlice from '../slices/languageSlice';
import location from "../slices/location-slice";
import dateSlice from "../slices/date-slice";

import servicesfilterSlice from '../slices/servicesfilterSlice';
import eventfilterSlice from '../slices/eventFilterSlice';
import { FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';

const encryptor = encryptTransform({
  secretKey: 'Aashish_Zimo_oevent_user',
});

const reducers = combineReducers({
  auth: AuthSlice,
  cartList: CartSlice,
  CartEventList: CartEventSlice,
  servicesfilter: servicesfilterSlice,
  eventfilter: eventfilterSlice,
  location: location,
  dateSlice: dateSlice,
  language: LanguageSlice,

});

const persistConfig = {
  key: 'root',
  storage,
  transforms: [encryptor],
  blacklist: ["servicesfilter", "eventfilter", "searchSlice"],
  whitelist: ["auth", "cartList", "location", "dateSlice", "languageCurrencySlice", "language"],
};

const persistedReducer = persistReducer(persistConfig, reducers);

const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== 'production',
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export default store;
